import script from "./NewTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTransfer.vue?vue&type=script&setup=true&lang=js"

import "./NewTransfer.vue?vue&type=style&index=0&id=2195765e&lang=scss"
import "./NewTransfer.vue?vue&type=style&index=1&id=2195765e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2195765e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QScrollObserver from 'quasar/src/components/scroll-observer/QScrollObserver.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QForm,QToggle,QSlideTransition,QBtn,QSelect,QField,QSkeleton,QScrollObserver,QHeader,QFooter,QCheckbox,QInnerLoading});qInstall(script, 'directives', {Intersection});
